Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};
Greenmile.Toolbar.Map.TagsGeofenceActions = Greenmile.Toolbar.Map.TagsGeofenceActions || {};

Greenmile.Toolbar.Map.TagsGeofenceActions = function (map, selector) {

    const storeMapPosition = new Greenmile.Storage.StoreMapPosition();

    this.entity = 'Tag';

    this.classSelector = 'tagsGeofence';

    this.selector = selector;

    this.updateTag = (tag) => {

        const found = Monet.Session.TagList.Geofence.tagsList.filter(function(t){
            return tag.id == t.id;
        })[0];

        if( found ) {

            if(found.description !== tag.description ||
               found.enabled !== tag.enabled ||
               found.tagColor !== tag.tagColor
            ) {
                found.description = tag.description;
                found.enabled = tag.enabled;
                found.tagColor = tag.tagColor;
            }

        } else {
            Monet.Session.TagList.Geofence.tagsList.push(tag);
        }

    };

    this.removeTag = (list) => {
        Monet.Session.TagList.Geofence.tagsList.forEach(function(oldTag, index, tags) {
            if(!list.filter((tag) => oldTag.id == tag.id)[0]) {
                tags.splice(index, 1);
            }
        });
    };

    this.requestTags = (callback) => {

        let tags = [];
        const ajax = new Monet.Ajax();
        ajax.url = `${this.entity}/restrictions?criteria={"filters":[ "id", "description" ]}`;
        ajax.method = 'POST';
        ajax.data = '{"criteriaChain":[{"and":[{"attr":"tagType","eq":"GEOFENCE"}]}],"sort":[{"attr":"description","type":"ASC"}]}';

        ajax.success = (tags) => {
            if (tags) {
                const geofenceObjectName = this.getGeofenceObjectNameBySelector(this.selector)
                Monet.Session.TagList = Monet.Session.TagList || {};
                Monet.Session.TagList.Geofence = Monet.Session.TagList.Geofence || {};
                Monet.Session.TagList.Geofence.tagsList = tags;

                let existInLocalStorage = storeMapPosition.getGeofenceTagFromUser(geofenceObjectName).length > 0;
                if (!existInLocalStorage) {
                    var geofencesToLocalStorage = storeMapPosition.createListGeofencetTags();
                    storeMapPosition.setGeofenceTagFromUser(geofencesToLocalStorage, geofenceObjectName);
                } else {
                    storeMapPosition.checkGeofencesOnLocalStorage(geofenceObjectName);
                }

                if(callback) {
                    callback(tags);
                }
            }
        };

        ajax.error = (responseText) => {
            this.showErrorExceptionOnTagEquipment(responseText);
        };

        ajax.send();

        return tags;
    };

    this.showErrorExceptionOnTagEquipment = (responseText) => {
        console.error(responseText);
    };

    this.setSelector = (selector) => this.selector = selector;

    this.getSelector = () => this.selector || '';

    this.getTextSelector = () => this.selector ? this.selector.replace(/[^0-9a-z]/gi, '') : '';

    this.appendTextSelector = () => this.selector ? this.getTextSelector() + '-' : '';

    this.getListTags = (callback) => (this.requestTags(callback));

    this.getOptionSelected = () => ( storeMapPosition.getGeofencesTagsMarked(this.getTextSelector()) );

    this.getGeofenceObjectNameBySelector = (selector) => selector !== ".routeMonitorRightPanelBody" ? "routeDetailMap" : "routeMonitorRightPanelBody";

    this.markCheckBox = (geofencesMarked) => ( geofencesMarked.forEach((geofence) =>  $("#GEOFENCE-" + this.appendTextSelector() + geofence.id).prop("checked", true)) );

    this.makeAction = () => {
        const selectedTagsArray = document.querySelectorAll(this.getSelector() + ' .tagsContainer.tagsGeofence input[type="checkbox"]:checked.' + this.classSelector);
        const size = selectedTagsArray.length;
        const storePosition = new Greenmile.Storage.StoreMapPosition();
        const geofenceObjectName = this.getGeofenceObjectNameBySelector(this.selector);

        if (size > 0) {
            var tagIds = [];
            for (var i = 0; i < size; i++) {
                tagIds.push(parseInt(selectedTagsArray[i].id.replace("GEOFENCE-" + this.appendTextSelector(), ""), 10));
            }
            this.getGeofenceByTags(tagIds);
            storePosition.updateGeofenceTags(selectedTagsArray, this.getTextSelector(), geofenceObjectName);
        } else {
          const layers = Monet.Session.TagList?.Geofence?.layers;

          if (layers) {
            map.removeLayer(layers);
            storePosition.updateGeofenceTags(null, this.getTextSelector(), geofenceObjectName);
          }
        }
    };

    this.addListeners = () => {
        const listCheckbox = document.querySelectorAll(this.getSelector() + ' .tagsContainer.tagsGeofence input[type="checkbox"].' + this.classSelector);
        const selectAllCheckbox = document.getElementById(`${this.getTextSelector()}-${this.classSelector}-selectAll`);

        if (listCheckbox && selectAllCheckbox) {
          selectAllCheckbox.addEventListener("change", (ev) => {
            for (let i = 0; i < listCheckbox.length; i++) {
                listCheckbox[i].checked = ev.target.checked;
            }
            this.makeAction();
          });

          for (let i = 0; i < listCheckbox.length; i++) {
              listCheckbox[i].addEventListener("change", () => {
                  this.makeAction();
                  this._verifyCheckSelectAll();
              });
          }
          this._verifyCheckSelectAll();
        }
    };

    this._verifyCheckSelectAll = () => {
        const selectAllCheckbox = document.getElementById(`${this.getTextSelector()}-${this.classSelector}-selectAll`);
        const allCheckboxCount = document.querySelectorAll(this.getSelector() + ' .tagsContainer.tagsGeofence input[type="checkbox"].' + this.classSelector).length;
        const selectedCheckboxCount = document.querySelectorAll(this.getSelector() + ' .tagsContainer.tagsGeofence input[type="checkbox"]:checked.' + this.classSelector).length;

        if (selectedCheckboxCount < allCheckboxCount) {
            selectAllCheckbox.checked = false;
        } else {
            selectAllCheckbox.checked = true;
        }
    }

    this.getGeofenceByTags = (tagIds) => {

        if(!tagIds || !tagIds.length) {
            return;
        }
        var data = '[';
        for (var i = 0; i < tagIds.length; i++) {
            data += tagIds[i] + ',';
        }
        data = data.slice(0, data.length - 1);
        data += ']';

        let tags = null;

        const ajax = new Monet.Ajax();
        ajax.url = 'Geofence/FindByTags';
        ajax.method = 'POST';
        ajax.data = data;
        ajax.success = (data) => {
            if (data) {
                this.drawGeofencesOnMap(data);
            }
        };
        ajax.send();

        return tags;
    };

    this.drawGeofencesOnMap = function (geofences) {
        if (!Monet.Session.TagList.Geofence.layers) {
          Monet.Session.TagList.Geofence.layers = {};
        } else {
          map.removeLayer(Monet.Session.TagList.Geofence.layers);
        }


        if (geofences && geofences.length > 0) {
            var drawnItems = new L.FeatureGroup();
            var allPoints = [];

            for (var i = 0; i < geofences.length; i++) {

                var geofence = geofences[i];
                var points = App.Views.Geofence.getGeofencePoints(geofence);
                var options = { color: geofence.color, className: 'geofencePath' };
                var polygon = new L.Polygon(points, options);

                drawnItems.addLayer(polygon);
                allPoints = allPoints.concat(points);

                polygon.bindPopup('<div class="address">' + geofence.description + '</div>', {
                    offset: L.point(35, 18)
                });
            }

            allPoints = allPoints.filter((point) => {
                if(point[0] && point[1]) {
                    return point;
                }
            });

            if (allPoints.length) {
                map.fitBounds(allPoints);
            }

            Monet.Session.TagList.Geofence.layers = drawnItems;
            map.addLayer(drawnItems);

        }
    };

    this.removeGeofencesByTag = function (tagId) {
        if (tagId) {
            var layerToRemove = Monet.Session.TagList.Geofence.layers;
            map.removeLayer(layerToRemove);
        }
    };

};
